import { openTextFile, saveTextFile } from "./file-io.js";

/** JSON backup file I/O — thin wrappers over the generic {@link file-io} module. */

const JSON_KIND = { name: "JSON", extensions: ["json"], mime: "application/json" };

export async function saveBackupFile(json: string, defaultName: string): Promise<void> {
  await saveTextFile(json, defaultName, JSON_KIND);
}

export async function openBackupFile(): Promise<string | null> {
  return openTextFile(JSON_KIND);
}
